<template>
  <span class="checkInputSingle">
    <span v-if="type === 'link'">
      <a :id="'labelFor-' + fname" @click="click()">
        <template v-if="$te(label)">
          {{ $t(label) }}
        </template>
        <template v-else>
          {{ label }}
        </template>
      </a>
    </span>
    <span v-if="type === 'radio'">
      <input
        :name="fname"
        class="with-gap"
        :disabled="disabled"
        type="radio"
        :id="fname + '-' + _uid"
        :checked="innerValue"
        v-on:click="click()"
      />
      <label :for="fname + '-' + _uid" :id="'labelFor-' + fname">
        <template v-if="$te(label)">
          {{ $t(label) }}
        </template>
        <template v-else>
          {{ label }}
        </template>
        <slot></slot
      ></label>
    </span>
    <button @click="click()" v-if="type === 'button'" v-bind:class="{ disable: !value }">
      <template v-if="$te(label)">
        {{ $t(label) }}
      </template>
      <template v-else>
        {{ label }}
      </template>
      <slot></slot>
    </button>
    <transition name="slidedown">
      <div v-if="errors.length && (!untouched || showAllErrors)" class="validationErrors">
        <small v-for="error in errors" :key="error">
          {{ $t(error) }}
        </small>
      </div>
    </transition>
  </span>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RadioInputSingle',
  components: {},
  data() {
    return {
      untouched: true,
      innerValue: this.value,
    };
  },
  computed: {
    ...mapState({
      showAllErrors: (state) => state.showAllValidationErrors,
    }),
  },
  props: {
    value: { default: false },
    disabled: { type: Boolean, default: false },
    label: { default: '' },
    fname: { required: true, default: '' },
    type: { default: 'checkbox' },
    errors: {
      default() {
        return [];
      },
    },
  },
  methods: {
    blur() {
      this.untouched = false;
    },
    click() {
      this.untouched = false;
      // if (this.type === 'button') {
      this.innerValue = true;
      // }
      this.$emit('input', { [this.fname]: true });
    },
  },
  watch: {
    value(v) {
      if (v !== this.innerValue) {
        this.innerValue = v;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/buttons';

a {
  cursor: pointer;
}

button {
  @extend .btn;
  @extend .btn-primary;
}
.validationErrors {
  margin-top: 20px;
}
button.disable {
  background-color: white;
  color: #222;
}
button:focus {
  outline: 0;
  box-shadow: unset;
}
label {
  margin-left: 1em;
}
</style>
